import {
  Breadcrumb,
  Button,
  Form,
  Input,
  Popconfirm,
  Space,
  Table,
  Tooltip,
} from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { ReactComponent as Editicon } from "../../image/Editicon.svg";

import "antd/dist/antd.min.css";
import { debounce } from "lodash";
import { getRequest, postRequest } from "../../axios";
import ButtonField from "../../common/htmlComponents/ButtonField";
import PlusSquareOutlined from "../../image/PlusSquareOutlined.svg";
import SearchIcon from "../../image/SearchIcon.svg";
import "../../styles/Main.scss";
// import { authUserData } from "../../utils/Helper";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import { authUserData } from "../../utils/Helper";
import { UndoOutlined } from "@ant-design/icons";

const UserRoleList = () => {
  const { Search } = Input;
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [selectedRow, setSelectedRow] = useState([]);
  const [reload, setReload] = useState(false);
  const [loading, setLoading] = useState(false);
  const [userroleList, setUserRoleList] = useState([]);
  const [totalCount, settotalCount] = useState(0);

  const [state, setState] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10,
    search: "",
    total: 0,
  });

  useEffect(() => {
    const getRoleList = async () => {
      // setLoading(true);

      try {
        // let apiResponse = await getRequest("get-group/", state);
        const params = {
          ...state, // existing state: page, pagesize, search, ordering
          fields: "group_id,group_name",
        };
        let apiResponse = await getRequest("create-group-permissions/", params);

        // if (apiResponse.data.results.success) {
        if (apiResponse.data.success) {
          setUserRoleList(apiResponse.data.response);
          // setUserRoleList([]);
          settotalCount(apiResponse.data.count);
        } else {
          ErrorNotificationMsg(t("error_in_user_role"));
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    getRoleList();
  }, [state, reload, t]);

  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";
    if (sortField === "group_id" && sortOrder === "ascend") {
      sortingEnumKey = "group_id";
    }
    if (sortField === "group_id" && sortOrder === "descend") {
      sortingEnumKey = "-group_id";
    }
    if (sortField === "group_name" && sortOrder === "ascend") {
      sortingEnumKey = "name";
    }
    if (sortField === "group_name" && sortOrder === "descend") {
      sortingEnumKey = "-name";
    }

    return sortingEnumKey;
  };

  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };

  const handleReset = () => {
    setState({
      ...state,
      search: "",
    });

    form.setFieldsValue({ search: "" });
  };
  const onSearch = (value) => {
    setState({
      ...state,
      search: value,
    });
  };

  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);
  const columns = [
    {
      title: "ID",
      dataIndex: "group_id",
      key: "group_id",
      width: 50,
    },
    {
      title: "role",
      dataIndex: "group_name",
      key: "group_name",
      sorter: true,
    },

    {
      title: "action",
      key: "operation",
      fixed: "right",
      width: "100px",
      render: (text, record) => (
        <Space>
          {/* <Tooltip title="Edit" placement="right"> */}
          {authUserData()?.permission.includes("auth|change_group") && (
            <Link
              to={{
                pathname: "/user-role/edit/" + btoa(record.group_id),
              }}
            >
              <Editicon />
            </Link>
          )}
          {/* </Tooltip> */}
          <Popconfirm
            className="action"
            title={t("pop_title")}
            okText={t("pop_ok")}
            cancelText={t("pop_cancel")}
          ></Popconfirm>
        </Space>
      ),
    },
  ];

  const handleArchive = async (id = "") => {
    let ids = selectedRow;
    if (ids.length === 0) {
      ids.push(id);
    }
    try {
      let apiResponse = await postRequest("delete-group-permissions/", {
        group_ids: ids,
      });
      if (apiResponse.data.success) {
        SuccessNotificationMsg(t("user_role_archive_successfully"));
        setReload(!reload);
        setSelectedRow([]);
      } else {
        ErrorNotificationMsg(t("error_in_archive_user_role"));
      }
    } catch (error) {
      ErrorNotificationMsg(error);
    }
  };
  const colors = ["#737373"];
  return (
    <>
      <div className="mainwrapper">
        <div className="ListingTopBar">
          <div className="pagenamewrap">
            <div className="pagename">
              {/* <Tooltip
              color={colors}
              placement="right"
              title={
                <span style={{ color: "#fff" }}>
                  The ability to update roles and assign permissions for specific
                  roles can typically be managed within the platform&apos;s administrative settings.
                </span>
              }
            > */}
              <h3>{t("pl_role_listing")}</h3>
              {/* </Tooltip> */}
              <Breadcrumb className="Breadcrumb-Sec">
                <Breadcrumb.Item>
                  <Link to="/dashboard">{t("home")}</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>{t("pl_roles")}</Breadcrumb.Item>
              </Breadcrumb>
            </div>
            <Space>
              <div className="searchwrp">
                <Space direction="vertical">
                  <Form form={form}>
                    <Form.Item name="search" initialValue="">
                      <Search
                        prefix={
                          <img
                            src={SearchIcon}
                            alt="SearchIcon"
                            className="SearchIcon"
                            width={22}
                          />
                        }
                        placeholder={t("pl_search_list")}
                        onChange={searchCallbackDelayed}
                      />
                    </Form.Item>
                  </Form>
                </Space>
              </div>
              {state?.search ? (
                // <Tooltip title="Reset search">
                <Button
                  className="BlueShadowBtn"
                  type="primary"
                  htmlType="button"
                  onClick={() => handleReset()}
                >
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <UndoOutlined style={{ fontSize: "18px", color: "#fff" }} />{" "}
                    Reset
                  </span>
                </Button>
              ) : (
                // </Tooltip>
                ""
              )}
              {/* <Tooltip
              color={colors}
              placement="right"
              title={
                <span style={{ color: "#fff" }}>
                  Create A New Role To Define Specific Permissions And Access Levels For Users.
                </span>
              }
            > */}
              {authUserData()?.permission.includes("auth|add_group") && (
                <Button
                  className="BlueShadowBtn"
                  type="primary"
                  onClick={() => navigate("/user-role/add")}
                  icon={<img src={PlusSquareOutlined} alt="Plus Square" />}
                >
                  {t("pl_add_role")}
                </Button>
              )}
              {/* </Tooltip> */}
              {selectedRow.length > 0 && (
                <Popconfirm
                  className="action"
                  title={t("pop_title")}
                  okText={t("pop_ok")}
                  cancelText={t("pop_cancel")}
                  placement="left"
                  onConfirm={() => handleArchive()}
                >
                  <ButtonField
                    className="BlueShadowBtn"
                    type="primary"
                    htmlType="button"
                    label={t("pl_archive")}
                  />
                </Popconfirm>
              )}
            </Space>
          </div>
        </div>
        <section className="grid-sec">
          <div className="Package-body">
            <div className="tablewrp">
              <Table
                columns={columns}
                rowKey={(record) => record.id}
                dataSource={userroleList}
                loading={loading}
                pagination={{
                  defaultCurrent: state.page,
                  defaultPageSize: state.pagesize,
                  total: totalCount,
                  showTotal: (total) => `Total ${total} items`,
                  showSizeChanger: true,
                  locale: {
                    items_per_page: "Items / Page",
                  },
                }}
                onChange={handleTableChange}
                scroll={{ x: 600 }}
              />
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default UserRoleList;
